<template>
    <div v-show="elementShown" class="container hidable-home-title">
        <div class="row">
            <div class="col-12">
                <h2>
                    Films
                </h2>
            </div>
        </div>
    </div>
</template>

<script>
    import HidableElement from '../mixins/HidableElement';

    export default {
        mixins: [
            HidableElement,
        ],
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/home/HidableHomeMoviesTitle.vue